import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=9d6a00ae&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=9d6a00ae&prod&lang=scss&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=9d6a00ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6a00ae",
  null
  
)

export default component.exports